<template>
  <div class="footer-content__wrapper">
    <div class="footer-content__logo-wrapper">
      <a-icon
        :icon="$options.consts.ICON.FM_LOGO"
        :no-hover="true"
        :original="true"
        :width="102"
        :height="45"
        class="footer-content__logo"
      />
    </div>

    <div class="footer-content__info-wrapper">
      <p class="footer-content__info">
        Finance Magnates Group is the leading source for financial news, events,
        analysis, and research.
      </p>

      <div class="footer-content__link-icon-wrapper">
        <div class="footer-content__icon-wrapper">
          <a-icon
            :icon="$options.consts.ICON.ENVELOP"
            :no-hover="true"
            :original="true"
            :width="20"
            :height="20"
            class="footer-content__link-icon"
          />
        </div>

        <a :href="`mailto:${$options.consts.AWARDS_EMAIL}`">
          {{ $options.consts.AWARDS_EMAIL }}
        </a>
      </div>
    </div>

    <div class="footer-content__socials">
      <div
        v-for="socialIcon in socialIcons"
        :key="socialIcon.icon"
        class="footer-content__social-icon-wrapper"
      >
        <a-icon
          :icon="socialIcon.icon"
          :to="socialIcon.link"
          :no-hover="true"
          :original="true"
          :width="30"
          :height="30"
          :aria-label="socialIcon.ariaLabel"
          class="footer-content__social-icon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'

export default {
  name: 'FooterContent',
  components: { AIcon },
  consts: {
    ICON,
    AWARDS_EMAIL: 'awards@financemagnates.com'
  },
  data() {
    const domain = this.$helper.removeEndingSlashes(this.$env.FM_DOMAIN_URL)

    return {
      socialIcons: [
        {
          icon: ICON.SOCIAL_TWITTER,
          link: 'https://twitter.com/financemagnates/',
          ariaLabel: 'FM Twitter'
        },
        {
          icon: ICON.SOCIAL_TELEGRAM,
          link: 'https://t.me/financemagnatesnews',
          ariaLabel: 'FM Telegram'
        },
        {
          icon: ICON.SOCIAL_YOUTUBE,
          link: 'https://www.youtube.com/channel/UCaMiOoCIu0Lb_bEO_V2kI_g',
          ariaLabel: 'FM Youtube'
        },
        {
          icon: ICON.SOCIAL_FACEBOOK,
          link: 'https://www.facebook.com/financemagnates/',
          ariaLabel: 'FM Facebook'
        },
        {
          icon: ICON.SOCIAL_LINKEDIN,
          link: 'https://www.linkedin.com/company/financemagnates/',
          ariaLabel: 'FM LinkedIn'
        },
        {
          icon: ICON.SOCIAL_RSS,
          link: `${domain}/feed/`,
          ariaLabel: 'FM RSS'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-content__wrapper {
  display: flex;
  flex-direction: column;

  $max-width: (
    $above-desktop-xl: 715px,
    $mobile: 100%
  );

  @include setStyleByBreakpoint('max-width', $max-width);

  .footer-content__logo-wrapper {
    width: 102px;
    height: 45px;
    margin-bottom: 18px;
  }

  .footer-content__info-wrapper {
    margin-bottom: 18px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 16px;
    line-height: 24px;

    @include tablet {
      flex-direction: column;
    }
  }

  .footer-content__info {
    $max-width: (
      $above-desktop-xl: 363px,
      $tablet: 100%
    );

    @include setStyleByBreakpoint('max-width', $max-width);

    @include tablet {
      margin-bottom: 32px;
    }
  }

  .footer-content__link-icon-wrapper {
    display: flex;
  }

  .footer-content__icon-wrapper {
    width: 20px;
    height: 20px;
    margin-right: 15px;
  }

  .footer-content__socials {
    display: flex;
  }

  .footer-content__social-icon-wrapper {
    width: 30px;
    height: 30px;
    margin-right: 18px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
